import React from "react";
import CompressImage from "../../../elements/CompressedImage";
import { classNames } from "../../../../helpers/classNames";
import useFetch from "../../../../hooks/useFetch";
import { getBlogList } from "../../../../services/BlogService";
import dayjs from "dayjs";
import NoImage from "../../../../assets/images/no-image-available.png";
import Image from "../../../elements/Image";

const DashboardNewsLists = ({ index = 0 }) => {
  const colors = ["bg-chestnut-rose", "bg-[#192B37]"];

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["event"],
    fetchFunction: async () => {
      const res = await getBlogList({
        limit: 15,
        page: 1,
        upcomingEvent: true,
        type: "event",
        sortQuery: "-createdAt",
      });
      return res?.docs;
    },
  });

  return (
    <div>
      {data?.data?.map((item, index) => (
        <div
          key={index}
          className={classNames(
            "relative block xls:flex items-center py-8 px-8 group",
            colors[index % colors.length]
          )}
        >
          <div className="md:flex mb-8 xls:mb-0">
            <div className="flex-shrink-0 w-48 flex flex-col items-left md:items-center justify-start md:justify-center text-white">
              <div className="text-4xl sm:text-5xl leading-none font-bold font-CanelaDeck">
                {dayjs(item?.publishDate)?.format("DD")}
              </div>
              <div className="text-sm sm:text-base xls:text-xl font-semibold font-CanelaDeck">
                {dayjs(item?.publishDate)?.format("MMMM")}
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-4 pl-0 md:pl-11 lg:pl-16 pr-0 md:pr-11 lg:pr-16 2xl:pr-40 md:border-l border-white text-white py-4">
              <h2 className="text-xl font-bold">{item?.title}</h2>
              <div
                className="text-base font-Gotham font-medium !leading-normal"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              />
            </div>
          </div>
          <div className="flex-shrink-0 xls:w-96">
            <div className="w-full lg:w-[700px] xls:w-full overflow-hidden flex xls:aspect-[4/3] bg-shades-03 mx-auto">
              <Image
                src={item?.image?.url || NoImage}
                alt={"image"}
                classes={classNames(
                  "w-full h-full object-center !bg-transparent",
                  item?.image?.url
                    ? "object-cover"
                    : "object-contain scale-[0.6]"
                )}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardNewsLists;
